let isAndroid =
  navigator.userAgent.indexOf('Android') > -1 ||
  navigator.userAgent.indexOf('Adr') > -1;
let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

/**
 * 详细文档
 * https://www.yuque.com/docs/share/9fa0a468-afa5-4cde-9d60-71da549f58d6（密码：qkbp）
 */

// 创建一些设置
function setupWebViewJavascriptBridge(callback) {
  // Android使用
  if (isAndroid) {
    if (window.WebViewJavascriptBridge) {
      // eslint-disable-next-line no-undef
      callback(WebViewJavascriptBridge);
    } else {
      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        function () {
          callback(WebViewJavascriptBridge); // eslint-disable-line
        },
        false,
      );
    }
  }

  // iOS使用
  if (isiOS) {
    if (window.WebViewJavascriptBridge) {
      // eslint-disable-line
      return callback(window.WebViewJavascriptBridge); // eslint-disable-line
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    let WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
}

// 注册回调函数，第一次连接时调用 初始化函数(android需要初始化,ios不用)
// setupWebViewJavascriptBridge(function (bridge) {
//   if (isAndroid) {
//     // 初始化
//     bridge.init(function (message, responseCallback) {
//       let data = {
//         'Javascript Responds': 'Wee!',
//       };
//       responseCallback(data);
//     });
//   }
// });

export default {
  /**
   * js 调用 native 提供的方法
   *
   * @param name 方法名
   * @param data 传给 App 的数据
   * @param callback 回调
   */
  // eslint-disable-next-line no-unused-vars
  callHandler(name, data, callback) {
    return new Promise(resolve => {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler(name, JSON.stringify(data), response => {
          console.log(response, 'response')
          if (typeof response === 'string') {
            response = JSON.parse(response);
            console.log(response, 'response Parse')
          }
          // 调用成功，使用保留的resolve改变返回的promise状态
          resolve(response);
        });
      });
    });
  },

  /**
   * 注册提供 native 调用的方法
   * @param {string} name 方法名称
   * @param {function} success 回调方法， 两个参数 data, callback
   * 第一个参数是 native 传递的数据 data
   * 第二个参数是 native 提供的回调函数 callback，前端处理完成后可以通过 callback 通知 native
   */
  // eslint-disable-next-line no-unused-vars
  registerHandler(name, success) {
    setupWebViewJavascriptBridge(function (bridge) {
      // eslint-disable-next-line no-unused-vars
      bridge.registerHandler(name, data => {
        if (data && typeof data === 'string') {
          data = JSON.parse(data);
        }
        success(data);
      });
    });
  },

  // 由 Native 提供的接口
  /**
   * 获取用户信息
   *
   * @return 用户数据
   */
  async getUserInfo() {
    const data = await this.callHandler('getUserInfo');
    return data;
  },

  /**
   * 设置顶部导航栏相关样式
   */
  async setNavigationBar(params = {}) {
    return await this.callHandler('setNavigationBar', params);
  },

  /**
   * 跳转到应用内的某个原生页面
   *
   * @param url 原生页面路径，路径后可以带参数。
   *        参数与路径之间使用 ? 分隔，参数键与参数值用 = 相连，不同参数用 & 分隔；
   *        如 'url?key=value&key2=value2'
   */
  async nativeTo(url) {
    if (!url) {
      this.$toast('Bridge 参数缺失');
      throw new Error('Parameter url cannot be empty.');
    }
    return await this.callHandler('nativeTo', {
      url,
    });
  },

  /**
   * 每次调用此函数都新建一个 webview 实例，webview 实例的路径为参数中的 url。
   *
   * @param url 原生页面路径，路径后可以带参数。
   *        参数与路径之间使用 ? 分隔，参数键与参数值用 = 相连，不同参数用 & 分隔；
   *        如 'url?key=value&key2=value2'
   */
  async webviewTo(url) {
    if (!url) {
      this.$toast('Bridge 参数缺失');
      throw new Error('Parameter url cannot be empty.');
    }
    return await this.callHandler('webviewTo', {
      url,
    });
  },

  /**
   * 每次调用此函数都新建一个 webview 实例，webview 实例的路径为参数中的 url。
   *
   * @param delta 返回的页面数，如果 delta 大于现有页面数，则返回到首页。
   * @param data 当前页面退出后，传递给上一页面的数据，native 通过调用 js 提供的 setValue 函数，注入到页面中。
   */
  async webviewBack(delta = 1, data = {}) {
    return await this.callHandler('webviewBack', {
      delta,
      data,
    });
  },

  /**
   * 从本地相册选择图片、视频或使用相机拍摄照片、视频。
   *
   * @param count 最多可以选择的文件个数。
   * @param mediaType 文件类型。值为 image 或 video。
   * @param sourceType 选择图片的来源。值为 ['album', 'camera']，album 为相册，camera 为相机。
   */
  async chooseMedia({
    count = 9,
    mediaType = 'image',
    sourceType = ['album', 'camera'],
  }) {
    return await this.callHandler('chooseMedia', {
      count,
      mediaType,
      sourceType,
    });
  },

  /**
   * 选择位置
   */
  async chooseLocation() {
    return await this.callHandler('chooseLocation', {});
  },

  /**
   * 拨打电话
   *
   * @param phoneNumber 需要拨打的电话号码。
   */
  async makePhoneCall(phoneNumber) {
    if (!phoneNumber) {
      this.$toast('Bridge 参数缺失');
      throw new Error('Parameter phoneNumber cannot be empty.');
    }
    return await this.callHandler('makePhoneCall', {
      phoneNumber,
    });
  },
  
  // 由 Native 提供的接口
  /**
   * 调用扫一扫功能
   *
   * @return 扫描二维码结果
   */
  async scanCode() {
    const data = await this.callHandler('scanCode');
    return data;
  },

  // 由 Native 提供的接口
  /**
   * 获取当前经纬度
   *
   * @return 经度纬度
   */
  async getLocation() {
    const data = await this.callHandler('getLocation');
    return data;
  },
  // 由 Native 提供的接口
  /**
   * 设置右侧导航栏呼出菜递内需要的list [key:'', value: '']
   *
   * @return 经度纬度
   */
  async setRightMenu(param) {
    const data = await this.callHandler('setRightMenu', param);
    return data;
  },

  // 由 JS 提供的接口
  /**
   * 向 h5 页面注入值。
   *
   * @param callback 回调函数。
   */
  async setValue(callback) {
    this.registerHandler('setValue', callback);
  },

  /**
   * 点击导航栏右侧。
   *
   * @param callback 回调函数。
   *
   */
  onClickNavigationBarRight(callback) {
    this.registerHandler('onClickNavigationBarRight', callback);
  },
  /**
   * 点击导航菜单
   *
   * @param callback 回调函数。
   *
   */
  onClickMenu (callback) {
    this.registerHandler('onClickMenu', callback);
  },
  onLoad (callback) {
    this.registerHandler('onLoad', callback);
  },
  
  onShow (callback) {
    this.registerHandler('onShow', callback);
  },
  onHide (callback) {
    this.registerHandler('onHide', callback);
  },
  isAndroid,
  isiOS,
};
